// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"6df8d869","135":"5e28acd5","224":"a3c3bfa4","481":"3c74b105","513":"98b0c961","567":"6e67b237","773":"a77335f0","962":"e6e66293"}[chunkId] + ".chunk.js";
};